
const CDN_BASE_URL = 'https://flagcdn.com';
const DEFAULT_HEIGHT = 12;
const DEFAULT_WIDTH = 16;
type AvailableFlagResolution =
  | '16x12'
  | '20x15'
  | '24x18'
  | '28x21'
  | '32x24'
  | '36x27'
  | '40x30'
  | '48x36'
  | '56x42'
  | '60x45'
  | '64x48'
  | '72x54'
  | '80x60'
  | '84x63'
  | '96x72'
  | '108x81'
  | '112x84'
  | '120x90'
  | '128x96'
  | '144x108'
  | '160x120'
  | '192x144'
  | '224x168'
  | '256x192';

type AurCountryFlagProps = {
  countryCode: string;
  flagResolution?: AvailableFlagResolution; // flag icon resolution
  height?: number; // icon height
  width?: number; // icon width
  altText: string;
};

const AurCountryFlag = ({
  countryCode = '',
  flagResolution = '48x36',
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
  altText = '',
}: AurCountryFlagProps) => {
  const sourceURL = `${CDN_BASE_URL}/${flagResolution}/${countryCode.toLowerCase()}.png`;

  return (
    <img
      src={sourceURL}
      width={`${width}`}
      height={`${height}`}
      alt={altText}
    />
  );
};

export default AurCountryFlag;
